const randomInt = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const addJitterToTime = (
  delay: number,
  options: { min: number; max: number } = { min: 0.5, max: 1.5 },
): number => {
  const min = Math.round(delay * options.min);
  const max = Math.round(delay * options.max);

  return randomInt(min, max);
};
